export enum ROLE_ENUM {
  ADMIN = 1,
  SECRETARIAT = 2,
  LEGISLATOR = 3,
}

export const Role = {
  [ROLE_ENUM.ADMIN]: 'システム運用者',
  [ROLE_ENUM.SECRETARIAT]: '議会事務局',
  [ROLE_ENUM.LEGISLATOR]: '議員',
};
